// ============================================================
// CONTACT FORM 7 — Integracja (checkboxy, radio, logika "Firma/Osoba")
// ============================================================

export function initContactForms() {
    const cf7Forms = document.querySelectorAll('.cf7-form-wp');
    if (cf7Forms.length === 0) return;

    cf7Forms.forEach(form => {
        // 1. Wstrzyknięcie customowego spanu dla checkboxów
        form.querySelectorAll('input[type="checkbox"]').forEach(cb => {
            if (!cb.nextElementSibling?.classList.contains('cf7-style-check-box')) {
                const span = document.createElement('span');
                span.className = 'cf7-style-check-box';
                cb.parentNode.insertBefore(span, cb.nextSibling);
            }
        });

        // 2. Obudowanie radio w <label class="form-radio__option">
        form.querySelectorAll('input[type="radio"]').forEach(radio => {
            const listItem = radio.closest('.wpcf7-list-item');
            if (!listItem || listItem.querySelector('.form-radio__option')) return;

            const label = document.createElement('label');
            label.className = 'form-radio__option';

            while (listItem.firstChild) {
                label.appendChild(listItem.firstChild);
            }
            listItem.appendChild(label);

            // Dodanie kropki radio
            if (!label.querySelector('.form-radio__dot')) {
                const dot = document.createElement('span');
                dot.className = 'form-radio__dot';
                radio.parentNode.insertBefore(dot, radio.nextSibling);
            }

            // Klasa dla tekstu etykiety
            label.querySelector('.wpcf7-list-item-label')?.classList.add('form-label');
        });

        // 3. Logika "Firma vs Osoba fizyczna"
        const radioGroup = form.querySelectorAll('input[name="client_type"]');
        if (radioGroup.length === 0) return;

        const applyClientTypeLogic = () => {
            const checked  = form.querySelector('input[name="client_type"]:checked');
            if (!checked) return;

            const isPerson = checked.value.toLowerCase().includes('osoba');
            form.classList.toggle('is-person', isPerson);

            if (isPerson) {
                form.querySelectorAll('.ask-on-offer__company-only input').forEach(inp => {
                    inp.value = '';
                });
            }
        };

        form.addEventListener('change', (e) => {
            if (e.target.name === 'client_type') applyClientTypeLogic();
        });

        applyClientTypeLogic();
    });
}
